import './index.less'

const PersonalInformationList = (props:any) => {
  return (
    <div className="word-file">
    {/* <h1>与第三方共享个人信息清单</h1> */}

    <p>1.为保障应用相关功能的实现与应用安全稳定的运行，我们可能会接入由合作方提供的软件开发包(SDK)、应用程序接口(API)、应用程序插件等代码或通过其他合作方式，以实现相关目的。</p>
    <p>2.我们会对获取信息的合作方的代码进行严格的安全监测，以保证数据安全。</p>
    <p>3.我们对接入的相关合作方在目录中列明，合作方具体的处理情况请参见合作方的隐私政策或服务协议。</p>
    <p>4.请注意，合作方的代码可能因为其版本升级，策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。</p>

    <h6>第三方SDK目录</h6>

    <div className="custom-table">
      <p>
        <span>第三方sdk名称</span>
        <span>所属公司</span>
        <span>收集信息</span>
        <span>使用目的</span>
        <span>隐私链接</span>
      </p>
      <p>
        <span>高德定位SDK</span>
        <span>高德软件有限公司</span>
        <span>
          位置信息(经纬度、精确位置、粗略位置)【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息(矢量、加速度、压力)、设备信号强度信息获取、外部储存目录】、设备标识信息(IMEI、IDFA、IDFV.Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(系统属性、设备型号、操作系统、运营商信息)、读取特定类型传感器列表
        </span>
        <span>用于用户位置服务(发布信息的位置定位);在软件处于后台状态，高德定位SDK会收集你的个人信息用于持续定位</span>
        <span>
          <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
        </span>
      </p>
      <p>
        <span>高德地图SDK</span>
        <span>高德软件有限公司</span>
        <span>
          位置信息(经纬度、精确位置、粗略位置)【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息(矢量、加速度、压力)、设备信号强度信息获取、外部储存目录】、设备标识信息(IMEI、IDFA、IDFV.Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(系统属性、设备型号、操作系统、运营商信息)、读取特定类型传感器列表
        </span>
        <span>用于在地图上显示用户当前位置以及附近的poi建筑</span>
        <span>
          <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
        </span>
      </p>
      <p>
        <span>高德导航SDK</span>
        <span>高德软件有限公司</span>
        <span>
        位置信息(经纬度、精确位置、粗略位置)【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息(矢量、加速度、压力)、设备信号强度信息获取、外部储存目录】、设备标识信息(IMEI、IDFA、IDFV.Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号)、当前应用信息(应用名、应用版本号)、设备参数及系统信息(系统属性、设备型号、操作系统、运营商信息)、读取特定类型传感器列表
        </span>
        <span>用于在地图上显示用户当前位置以及附近的poi建筑</span>
        <span>
          <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
        </span>
      </p>
      <p>
        <span>腾讯云通信SDK</span>
        <span>深圳市腾讯计算机系统有限公司</span>
        <span>设备信息(如设备型号、操作系统版本、唯一设备标识符（如Android ID、OAID）、设备序列号（SN）、设备MAC地址、IP地址、无线网络信息、传感器信息、屏幕分辨率、CPU信息)</span>
        <span>识别用户身份，保障账号安全。适配不同设备，确保SDK兼容性和正常运行。用于问题排查和数据分析（如崩溃分析）</span>
        <span>
          <a href="https://cloud.tencent.com/document/product/301/34003">https://cloud.tencent.com/document/product/301/34003</a>
        </span>
      </p>
      <p>
        <span>人脸核身SDK</span>
        <span>贵州数据宝网络科技有限公司</span>
        <span>个人身份信息(姓名、身份证号码)，人脸生物识别信息(面部特征值、人脸图像或视频)，设备信息(设备型号、操作系统版本、唯一设备标识符（如IMEI/OAID/IDFA）、IP地址、设备MAC地址、传感器信息)，网络信息(IP地址、网络类型)</span>
        <span>用于向公安等权威数据库发起核验请求，是“人证一致”比对的基础</span>
        <span>
          <a href="https://yikong.chinadatapay.com:8083/new_userprivacy.html">https://yikong.chinadatapay.com:8083/new_userprivacy.html</a>
        </span>
      </p>
      <p>
        <span>Bugly</span>
        <span>深圳市腾讯计算机系统有限公司</span>
        <span>设备状态及身份信息、存储读写权限、设备ID和设备序列号、联网信息、系统名称、系统版本以及国家码、设备标识符</span>
        <span>收集用户崩溃日志信息，提升app稳定性</span>
        <span>
          <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a>
        </span>
      </p>
      <p>
        <span>创蓝闪验SDK</span>
        <span>上海海否数据服务有限公司</span>
        <span>设备信息：本机号码、设备型号、厂商、系统版本、屏幕宽高、IP、网络制式、网络类型、SIM卡状态、运营商类型、subId、当前时间戳、idfv、唯一设备标识符（OAID）、MAC地址、bundleId、应用包名、应用宝签名。应用信息： 应用安装列表、应用包名、应用版本、应用前后台状态。其他信息： 本机手机号码（用于预取号登录）、当前时间戳。</span>
        <span>为APP 用户提供一键登录、号码验证、安全校验服务</span>
        <span>
          <a href="https://doc.chuanglan.com/document/B53QFYKZETHKETFC">https://doc.chuanglan.com/document/B53QFYKZETHKETFC</a>
        </span>
      </p>
      <p>
        <span>移动登录SDK</span>
        <span>中移互联网有限公司</span>
        <span>网络类型、网络地址（ip地址）、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商、OAID</span>
        <span>识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制</span>
        <span>
          <a href="https://doc.chuanglan.com/document/B53QFYKZETHKETFC">https://wap.cmpassport.com/uni-access/contactCm.html</a>
        </span>
      </p>
      <p>
        <span>号码认证SDK</span>
        <span>中移互联网有限公司</span>
        <span>网络类型、网络地址（ip地址）、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商、OAID</span>
        <span>识别⽤户的⼿机号码快速登录/号码校验，问题查询、分析、风险控制</span>
        <span>
          <a href="https://doc.chuanglan.com/document/B53QFYKZETHKETFC">https://wap.cmpassport.com/uni-access/contactCm.html</a>
        </span>
      </p>
      <p>
        <span>联通认证SDK</span>
        <span>联通在线信息科技有限公司</span>
        <span>网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商</span>
        <span>识别⽤户的⼿机号码快速登录/号码校验</span>
        <span>
          <a href="https://doc.chuanglan.com/document/B53QFYKZETHKETFC">https://ms.zzx9.cn/html/oauth/protocol2.html</a>
        </span>
      </p>
      <p>
        <span>天翼账号认证SDK</span>
        <span>天翼数字生活科技有限公司</span>
        <span>注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本</span>
        <span>识别⽤户的⼿机号码快速登录/号码校验及业务风控</span>
        <span>
          <a href="https://doc.chuanglan.com/document/B53QFYKZETHKETFC">https://e.189.cn/sdk/agreement/detail.do?hidetop=true</a>
        </span>
      </p>
      <p>
        <span>Android支持工具库</span>
        <span>/</span>
        <span>文件读写权限，摄像头以及麦克风使用权限，系统位置定位权限</span>
        <span>用于为APP内其它所使用的SDK提供基础功能调用。</span>
        <span>
          <a href="/.">/.</a>
        </span>
      </p>
      <p>
        <span>360加固SDK</span>
        <span>北京三六零智领科技有限公司</span>
        <span>无</span>
        <span>为应用提供安全加固服务</span>
        <span>
          <a href="https://jiagu.360.cn/#/global/help/32">https://jiagu.360.cn/#/global/help/32</a>
        </span>
      </p>
      <p>
        <span>中国移动认证</span>
        <span>中移互联网有限公司</span>
        <span>网络类型、网络地址、运营商类型、本机号码、SIM卡状态、手机设备类型、手机操作系统、硬件厂商、应用包名、应用包签名</span>
        <span>识别⽤户的⼿机号码快速登录及号码校验，问题查询、分析、风险控制</span>
        <span>
          <a href="https://wap.cmpassport.com/resources/html/contract.html">https://wap.cmpassport.com/resources/html/contract.html</a>
        </span>
      </p>
      <p>
        <span>中国电信认证</span>
        <span>天翼数字生活科技有限公司</span>
        <span>注册手机号码、本机号码、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本、应用包名、应用包签名</span>
        <span>识别用户手机号快速登录及号码校验，业务风控</span>
        <span>
          <a href="https://e.189.cn/sdk/agreement/detail.do?hidetop=true">https://e.189.cn/sdk/agreement/detail.do?hidetop=true</a>
        </span>
      </p>
      <p>
        <span>中国联通认证</span>
        <span>中国联合网络通信有限公司</span>
        <span>网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商、应用包名、应用包签名</span>
        <span>识别用户手机号快速登录及号码校验</span>
        <span>
          <a href="https://ms.zzx9.cn/html/oauth/protocol2.html">https://ms.zzx9.cn/html/oauth/protocol2.html</a>
        </span>
      </p>
      <p>
        <span>抖音SDK</span>
        <span>北京抖音科技有限公司</span>
        <span>接入抖音开放平台 SDK，支持抖音授权登录</span>
        <span>实现抖音授权、登录功能</span>
        <span>
          <a href="https://developer.open-douyin.com/docs/resource/zh-CN/dop/operation-standard/service-protocol/douyin-sdk-privacy-policy">https://developer.open-douyin.com/docs/resource/zh-CN/dop/operation-standard/service-protocol/douyin-sdk-privacy-policy</a>
        </span>
      </p>
      <p>
        <span>微信支付SDK</span>
        <span>财付通支付科技有限公司</span>
        <span>设备信息(设备型号、操作系统版本、唯一设备标识符（如Android ID、OAID）、设备序列号（SN）、设备MAC地址、IP地址、传感器信息、SIM卡信息、IMEI（在用户授权同意后）)</span>
        <span>风险控制和安全认证。 识别设备，防止欺诈交易、套现、刷单等恶意行为，保障您的资金安全。适配设备，保证SDK正常运行</span>
        <span>
          <a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=pay">https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=pay</a>
        </span>
      </p>
      <p>
        <span>支付宝支付SDK</span>
        <span>支付宝（杭州）信息技术有限公司</span>
        <span>用户支付的产品名和金额、支付时间等信息；Android ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP 地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi 参数、Wi-Fi 列表</span>
        <span>帮助用户在应用内使用支付宝进行支付，保障用户账户和资金安全以及支付服务的安全稳定运行</span>
        <span>
          <a href="https://opendocs.alipay.com/open/54/01g6qm">https://opendocs.alipay.com/open/54/01g6qm</a>
        </span>
      </p>
      <p>
        <span>阿里云oss SDK</span>
        <span>阿里云计算有限公司</span>
        <span>用户所上传的图片，音视频文件。</span>
        <span>在云上提供无层次结构的分布式存储产品，为用户提供单价较低且快速可靠的数据存储方案。</span>
        <span>
          <a href="https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html">https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html</a>
        </span>
      </p>
      <p>
        <span>华为推送SDK</span>
        <span>华为软件技术有限公司</span>
        <span>华为手机的ID、应用ID、应用包名、服务器公网IP地址，回执证书和回执地址URL信息（如开通了回执权益），iOS证书信息（如开通iOS权益），WebPush对应的密钥对信息（如开通WebPush权益），AAID（应用匿名标识）、Token、Topic订阅关系，消息下发记录、Token申请记录、显示/点击/关闭打点上报记录，缓存消息内容，设备信息，应用列表，存储读写权限</span>
        <span>为用户提供推送消息服务</span>
        <span>
          <a href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177</a>
        </span>
      </p>
      <p>
        <span>小米推送SDK</span>
        <span>北京小米移动软件有限公司</span>
        <span>小米手机的设备相关信息（IMEI、Android ID、MEID、Serial Number、OAID、GAID、VAID、AAID、MID、手机区域设置、设备型号、设备型号、网络类型、设备存储、设备运行进程信息、应用版本、SDK版本））、位置信息、WLAN接入点、应用信息（包名、版本号、应用名称、首次安装时间、上次完成更新的时间）</span>
        <span>为用户提供推送消息服务</span>
        <span>
          <a href="https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1819">https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1819</a>
        </span>
      </p>
      <p>
        <span>vivo推送SDK</span>
        <span>维沃移动通信有限公司</span>
        <span>Vivo手机的设备状态及身份信息、存储读写权限，系统版本号，设备标识符</span>
        <span>为用户提供推送消息服务</span>
        <span>
          <a href="https://dev.vivo.com.cn/documentCenter/doc/878">https://dev.vivo.com.cn/documentCenter/doc/878</a>
        </span>
      </p>
      <p>
        <span>oppo推送SDK</span>
        <span>广东欢太科技有限公司</span>
        <span>Oppo手机的设备相关信息（如IMEI或OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID, 手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）</span>
        <span>为用户提供推送消息服务</span>
        <span>
          <a href="https://open.oppomobile.com/documentation/page/info?id=11228">https://open.oppomobile.com/documentation/page/info?id=11228</a>
        </span>
      </p>
      <p>
        <span>荣耀推送SDK</span>
        <span>深圳荣耀软件技术有限公司</span>
        <span>荣耀手机的ID、应用ID、应用包名、服务器公网IP地址，回执证书和回执地址URL信息（如开通了回执权益），iOS证书信息（如开通iOS权益），WebPush对应的密钥对信息（如开通WebPush权益），AAID（应用匿名标识）、Token、Topic订阅关系，消息下发记录、Token申请记录、显示/点击/关闭打点上报记录，缓存消息内容，设备信息，应用列表，存储读写权限</span>
        <span>为用户提供推送消息服务</span>
        <span>
          <a href="https://developer.honor.com/cn/docs/11002/guides/sdk-data-security">https://developer.honor.com/cn/docs/11002/guides/sdk-data-security</a>
        </span>
      </p>
      <p>
        <span>Android_CN_OAID（OAID 聚合组件）</span>
        <span>开源项目（gzu-liyujiang）</span>
        <span>设备标识信息（OAID，及必要的设备标识补充信息）</span>
        <span>用于保障账号与服务安全、风控反作弊、统计分析与问题排查</span>
        <span>
          <a href="https://github.com/gzu-liyujiang/Android_CN_OAID">https://github.com/gzu-liyujiang/Android_CN_OAID</a>
        </span>
      </p>
      <p>
        <span>移动安全联盟 OAID（MSA）</span>
        <span>移动安全联盟（MSA）</span>
        <span>OAID（开放匿名设备标识符）</span>
        <span>用于设备标识、风险控制、统计分析</span>
        <span>
          <a href="https://www.msa-alliance.cn/">https://www.msa-alliance.cn/</a>
        </span>
      </p>
      <p>
        <span>HUAWEI Ads Identifier SDK</span>
        <span>华为终端有限公司</span>
        <span>设备标识相关信息（如 AAID）</span>
        <span>用于设备标识补充、统计分析与安全风控</span>
        <span>
          <a href="https://privacy-drcn.dbankcdn.cn/cch5/WiseSecurity-AS/hms-core_CN_b0_latest/default/privacy-statement-zh-cn.htm">https://privacy-drcn.dbankcdn.cn/cch5/WiseSecurity-AS/hms-core_CN_b0_latest/default/privacy-statement-zh-cn.htm</a>
        </span>
      </p>
      <p>
        <span>HONOR Ads Identifier SDK</span>
        <span>荣耀终端有限公司</span>
        <span>设备标识相关信息（含 OAID 相关能力）</span>
        <span>用于设备标识补充、统计分析与安全风控</span>
        <span>
          <a href="https://developer.honor.com/cn/docs/11002/guides/sdk-data-security">https://developer.honor.com/cn/docs/11002/guides/sdk-data-security</a>
        </span>
      </p>
    </div>
  </div>
  )
}

export default PersonalInformationList